// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductTile_container__ORgxM","image":"ProductTile_image__38Dse","title":"ProductTile_title__OZVVo","price":"ProductTile_price__Q4OjP"};